import Button from 'components/Button'
import TextBody from 'components/TextBody'
import {
  STYLES_BORDER_RADIUS,
  STYLES_COLOR,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'

function SelectButtonOption (props) {
  return (
    <div
      style={{
        width: props.isFullWidth ? '100%' : null,
        paddingBottom: props.paddingBottom,
        paddingRight: props.paddingRight
      }}
    >
      <Button
        height='auto'
        isFullWidth={props.isFullWidth}
        onClick={props.onClick}
        url={props.url}
        hasNoPadding={props.hasNoPadding}
        style={{
          padding: 0
        }}
      >
        <TextBody
          d='inline-block'
          style={{
            color: props.isSelected
              ? STYLES_COLOR.BLACK
              : STYLES_COLOR.BLACK_LIGHT,
            padding:
              props.hasNoPadding
                ? undefined
                : STYLES_PADDING.SMALL,
            border: props.isSelected
              ? `0.055em solid ${STYLES_COLOR.BLACK_MEDIUM}`
              : `0.055em solid ${STYLES_COLOR.BLACK_LIGHT}`,
            borderRadius: STYLES_BORDER_RADIUS.ROUNDED
          }}
        >
          {props.children}
        </TextBody>
      </Button>
    </div>
  )
}

SelectButtonOption.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  isSelected: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  hasNoPadding: PropTypes.bool,
  paddingBottom: PropTypes.string,
  paddingRight: PropTypes.string,
  onClick: PropTypes.func,
  url: PropTypes.string,
  padding: PropTypes.string
}
export default SelectButtonOption
